<template>
  <div class="content-container">
    <div class="flex-col">
      <div class="titles">
        <span class="title" :class="{ active: isLogin }" @click="loginClick">{{
          "login.titles.login" | translate
        }}</span>
        <span
          class="title"
          :class="{ active: !isLogin }"
          @click="registerClick"
          >{{ "register.titles.register" | translate }}</span
        >
      </div>
      <div class="horizontal-line"></div>
      <login-page v-if="isLogin"></login-page>
      <p v-if="isLogin">{{ "login.titles.new_to" | translate }}</p>
      <button
        v-if="isLogin"
        class="button black"
        type="button"
        @click="registerClick"
      >
        {{ "login.register" | translate }}
      </button>
      <register-page v-if="!isLogin"></register-page>
    </div>
  </div>
</template>

<script>
import LoginPage from "./LoginPage.vue";
import RegisterPage from "./RegisterPage.vue";
export default {
  components: { LoginPage, RegisterPage },
  name: "LoginRegister",
  data() {
    return {
      isLogin: true
    };
  },
  methods: {
    loginClick() {
      this.isLogin = true;
    },
    registerClick() {
      this.isLogin = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.content-container {
  margin-top: 5rem;
  margin-bottom: 5rem;
}

.titles {
  display: flex;
  flex-direction: row;

  .title {
    cursor: pointer;
    margin-right: 1rem;
    color: $brand-gray-medium;

    &.active,
    &:hover {
      color: $brand-black;
      font-weight: 700;
      position: relative;

      &::after {
        content: "";
        height: 2px;
        width: 100%;
        background-color: $brand-black;
        display: flex;
        position: absolute;
        bottom: -1px;
        left: 0;
      }
    }
  }
}

.flex-col {
  max-width: 20rem;
  margin: auto;
}

.horizontal-line {
  height: 2px;
  background-color: $brand-gray-light;
  width: 100%;
  margin: auto;
  margin-bottom: 1rem;
  max-width: 20rem;
}

p {
  text-align: center;
  white-space: pre-line;
  font-weight: 600;
}
</style>
